import { transport } from 'config/transport';

export function callApiSaveNoiTruNumberOfStudents(congDoanId, year, body) {
    return transport.post(`/noitru/${congDoanId}/thuchi/soluonghocsinh`, body, { params: { year } });
}
